'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'forklift';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f47a';
var svgPathData = 'M512 32l0 384 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-416c0-17.7 14.3-32 32-32s32 14.3 32 32zM160 160l64 96 90.4 0-68.6-160-85.8 0 0 64zm-64 0l0-80c0-26.5 21.5-48 48-48l112.3 0c19.2 0 36.6 11.4 44.1 29.1l79.7 185.9c2.5 5.8 3.9 12.2 3.9 18.9l0 90.3c19.5 16.1 32 40.6 32 67.9 0 48.6-39.4 88-88 88-40.3 0-74.2-27.1-84.7-64l-70.6 0c-10.4 36.9-44.4 64-84.7 64-48.6 0-88-39.4-88-88L0 224c0-35.3 28.7-64 64-64l32 0zm32 264a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm240 0a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faForklift = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;